import { render } from "./MandateSources.vue?vue&type=template&id=7f5d49d5"
import script from "./MandateSources.vue?vue&type=script&lang=js"
export * from "./MandateSources.vue?vue&type=script&lang=js"
script.render = render

export default script